<div class="button-list" [ngClass]="{'one-item': isOneItemOnly(), 'selected': button.selected(), 'disabled': button.isDisabled(button)}" *ngFor="let button of getVisibleButtons()"
    [soti-tooltip]="button.tooltip()" placement="left"
    (click)="button.onClick(button)">
    <span *ngIf="!isSotiPopup(button)" class="hd-icon {{button.icon()}} icon-lg device-icon"></span>
    <div #statusCenterPopupTrigger *ngIf="isSotiPopup(button)" [sotiPopupTriggerFor]="statusCenterPopup"
        [popUpOverlayBackdrop]="false" (popUpClosed)="popupOpened(false)" (popUpOpened)="popupOpened(true)">
        <mat-spinner class="button-spinner" [diameter]=30 [strokeWidth]=2 *ngIf="isAnyActionsInProgress()"></mat-spinner>
        <span  class="hd-icon {{button.icon()}} icon-lg device-icon"></span>
        <div class='failed-indicator' *ngIf="isSotiPopup(button) && isFailedIndicatorActive()"></div>
    </div>
    <soti-popup #statusCenterPopup="sotiPopup" position="endCenter" [noFallback]="true">
        <app-file-manager-status-center #fileManagerStatusCenter (tabSelect)="statusCenterTabChanged($event)" [getPopupTrigger]='getPopupTrigger'></app-file-manager-status-center>
    </soti-popup>
</div>
